export default "__VITE_ASSET__DwQiBUDC__"